import { forwardRef } from "react";
import {
  SegmentedControl as MantineSegmentedControl,
  SegmentedControlProps as MantineSegmentedControlProps,

} from "@mantine/core";

export interface SegmentedControlProps extends MantineSegmentedControlProps {
  onClick?: () => void;
  ariaLabel: string;
}

export const SegmentedControl = forwardRef<
  HTMLDivElement,
  SegmentedControlProps
>((props, ref) => {
  const { className, ariaLabel, ...rest } = props;

  return (
    <MantineSegmentedControl
      className={`clickable ${className}`}
      aria-label={ariaLabel}
      tt="none"
      {...rest}
      ref={ref}
    />
  );
});

SegmentedControl.displayName = "SegmentedControl";
